// Tracker mapping constants
export const TRACKER_LABELS: Record<string, string> = {
  tc: 'Click',
  ti: 'Impression',
  td: 'Drag & Drop',
  tk: 'Keyboard',
  th: 'Heatmap',
  tr: 'Recording',
  tp: 'Pageload'
};

// Helper function to get tracker label
export const getTrackerLabel = (trackerKey: string): string => {
  return TRACKER_LABELS[trackerKey] || trackerKey;
};
